import { ProductData } from 'utils/types';
import { StyledSingleProduct } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const SingleProduct = ({ product }: { product: ProductData }) => {
  const { images, name, quantityDisplay, strokedSaleQuantity } = product;
  return (
    <StyledSingleProduct>
      <div className="product-image">
        <img className="product-image-icon" src={images.product} alt={name} />
      </div>

      <div className="product-quantity">
        <AutoTextSize
          className="product-quantity-text"
          mode="oneline"
          maxFontSizePx={18}
          minFontSizePx={8}
          as="div"
          data-text={quantityDisplay}
        >
          {quantityDisplay}
        </AutoTextSize>
        <AutoTextSize
          className="product-quantity-stroked"
          mode="oneline"
          maxFontSizePx={14}
          minFontSizePx={8}
          as="div"
        >
          {strokedSaleQuantity}
        </AutoTextSize>
      </div>
    </StyledSingleProduct>
  );
};
